import { Link } from '@tanstack/react-router'
import { ArrowLeft, ArrowRight } from 'lucide-react'

export interface NavPost {
  title: string
  slug: string
}

export function ArticleNav({
  previous,
  next,
  locale,
  label,
  previousLabel,
  nextLabel,
}: {
  previous: NavPost | null
  next: NavPost | null
  locale: string
  label: string
  previousLabel: string
  nextLabel: string
}) {
  if (!previous && !next) return null
  return (
    <nav
      aria-label={label}
      className="mt-10 md:mt-16 flex items-start justify-between gap-4 border-t border-border pt-8"
    >
      {previous ? (
        <Link
          to="/$locale/blog/$slug"
          params={{ locale, slug: previous.slug }}
          className="group flex max-w-[48%] flex-col items-start gap-1 text-left"
        >
          <span className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <ArrowLeft className="size-4" />
            {previousLabel}
          </span>
          <span className="line-clamp-2 text-sm font-medium text-primary group-hover:underline">
            {previous.title}
          </span>
        </Link>
      ) : (
        <span />
      )}
      {next ? (
        <Link
          to="/$locale/blog/$slug"
          params={{ locale, slug: next.slug }}
          className="group ml-auto flex max-w-[48%] flex-col items-end gap-1 text-right"
        >
          <span className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            {nextLabel}
            <ArrowRight className="size-4" />
          </span>
          <span className="line-clamp-2 text-sm font-medium text-primary group-hover:underline">
            {next.title}
          </span>
        </Link>
      ) : (
        <span />
      )}
    </nav>
  )
}
